import {
  Button,
  Divider,
  Grid,
  GridColumn, Heading, ProgressTracker, ProgressTrackerItem, Skeleton,
  Switch, TextArea,
  useSnackbar
} from "@walmart-web/livingdesign-components";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { getService, patchService } from "../../../axios/axios";
import Label from "../../../components/TextField/Label/Label";
import { USER_REQUEST_SERVICE } from "../../../constants/baseURLs";
import {
  AddressTypes,
  ADDRESS_LINE_1,
  ADDRESS_LINE_2,
  ADDRESS_TYPE,
  APPROVAL_DATA, BILLING_CONTACT, CITY, CONTACT_INFO, COUNTRY, 
  detailModes as modes, DETAILS, CLASSIFICATION, START_DATE, TKID,
  EDIT_TIMEKEEPER_TITLE, EMAIL, END_DATE, FIRST_NAME, JD_YEAR,
  JUSTIFICATION_FOR_TIMEKEEPER, LAST_NAME, ORGANIZATION, PHONE_NUMBER,
  REQUESTER_EMAIL, ROLE,
  SELECT_SUBJECT_MATTER_EXPERTISE,
  SELECT_TYPE, START_END_DATE_VALIDATION_MESSAGE, STATE, STATE_BAR_LICENCE,
  SUBJECT_MATTER_EXPERTISE, WALMART_APPOVING_ATTORNEY, SELECT_STATE, SELECT_COUNTRY, SELECT_STATE_BAR_LICENSE, SELECT_CLASSIFICATION, CS_IS_LEAD_ATTORNEY_FILTER, EDIT_ADMIN_TITLE, CREATED_DATE,
  CS_IS_OC_INTERNAL_FILTER,
  OC_ADMIN,
  ADMIN_TIMEKEEPER_LABEL,
  IS_TIMEKEEPER_ROLE_ENABLED,
  TIMEKEEPER_LABEL,
  OC_TIMEKEEPER,
  ADD_ANOTHER_RATE,
  ADMIN_LABEL,
  PROFILE_INFO,
  RATE,
  SUMMARY} from "../../../constants/constants";
import { USER_DETAILS_UPDATE_MSG } from "../../../constants/messages";
import { resetTimeKeeperAdminValue, setInputValue, setPracticeAreaNew, setTimekeeperDetail } from "../../../store/actions/timeKeeperAdminActions";
import Detail from "../../Detail/Detail";
import EditTimeKeeperProfileStyles from "./EditTimeKeeperProfile.styles";
import { SUBJECT_MATTER_EXPERTISE_MSG } from "../../../Validation/validationMessages";
import MuiValidationMessage from "../../../Validation/MuiValidationMessage/MuiValidationMessage";
import { timekeeperValidationRules } from "../../../Validation/validationRules";
import { useForm } from "react-hook-form";
import { BACKEND_DATE_FORMAT, MOMENT_DATE_FORMAT, DATE_END_TIME, DATE_START_TIME, DATE_YYYY_MM_DD } from "../../../constants/dateFormats";
import { cleanValueString, convertPANameToCode, getErrorMessage, renderTernary } from "../../../helpers/utils";
import { filterPayload, formatPhoneNumber, phoneNumberForBackend } from "../../../helpers/commonUtils";
import MasterDataAutocomplete from "../../../components/Autocomplete/MasterDataAutocomplete/MasterDataAutocomplete";
import MasterDataMultiAutocomplete from "../../../components/Autocomplete/MasterDataMultiAutocomplete/MasterDataMultiAutocomplete";
import { convertToUTCDateTime } from "../../../helpers/utcUtils";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MenuItem, Select, TextField } from "@mui/material";
import PeopleAutocompleteWithOptions from "../../../components/Autocomplete/PeopleAutocompleteWithOptions/PeopleAutocompleteWithOptions";
import TimeKeeperAdminCreatePracticeArea from "../People/TimeKeeperAdminCreatePracticeArea";
import TimeKeeperAdminSummary from "../People/TimeKeeperAdminSummary";
import { Plus } from "@walmart-web/livingdesign-icons";
import { CANCEL, EDIT, GO_BACK, NEXT, UPDATE } from "../../../constants/actionButtons";
import { isValueValidList } from "../../../helpers/validationUtils";

const CHARACTER_LIMIT = 100;


const LoadField = ({ loader, skeletonHeight, skeletonVariant, skeletonLines = 1, node }) => {
  if (loader) {
    return <Skeleton height={skeletonHeight} variant={skeletonVariant} lines={skeletonLines} />;
  } else {
    return node;
  }
};

/**
 * EditTimeKeeperProfile component
 * Handles editing of a timekeeper or admin profile, including form state, validation, and update logic.
 */
const EditTimeKeeperProfile = () => {
  const classes = EditTimeKeeperProfileStyles()
  const dispatch = useDispatch();
  const history = useHistory()
  const [loading, setLoading] = useState(false);
  const { peopleId } = useParams();

  // Redux selectors for profile fields and supporting data
  const {
    firstName,
    lastName,
    emailId,
    primaryOfficeLocation,
    starBarLicense,
    subjectMatterExpertise,
    justificationForRole,
    tkId,
    classification,
    billingContact,
    organizationName,
    phoneNumber,
    jdYear,
    walmartApprovingAttorneyFullName,
    startDate,
    addressType,
    addressLine1,
    addressLine2,
    stateBarLicence,
    endDate,
    city,
    state,
    country,
    walmartApprovingAttorneyEmailId,
    walmartApprovingAttorneyFirstName,
    walmartApprovingAttorneyLastName,
    walmartApprovingAttorneyUserId,
    requesterEmailId,
    isTimeKeeperRoleEnabled,
    userRequestId,
    roleCodes,
    requestedRole
  } = useSelector((state) => state?.timeKeeperAdmin?.timeKeeperAdminValues);

  const practiceArea = useSelector(
    (state) => state?.timeKeeperAdmin?.timeKeeperAdminValues?.practiceAreaRate
  );
  const { addSnack } = useSnackbar();

  // React Hook Form setup for validation
  const { register, formState: { errors }, setError, clearErrors } = useForm({ mode: "all" });

  // Local state for Walmart attorney, edit values, and tab index
  const [walmartTimekeeperAttorney, setWalmartTimekeeperAttorney] = useState(walmartApprovingAttorneyFirstName ? {
    email: walmartApprovingAttorneyEmailId,
    firstName: walmartApprovingAttorneyFirstName,
    lastName: walmartApprovingAttorneyLastName,
    userId: walmartApprovingAttorneyUserId,
  } : '');
  const [editValues, setEditValues] = useState({});
  const [initailTkRole, setInitailTKRole] = useState(isTimeKeeperRoleEnabled);
  const [tabIndex, setTabIndex] = useState(0);

  // Initial values for practice area and form
  const practiceAreaInititalValues = useSelector(
    (state) => state?.timeKeeperAdmin?.timeKeeperAdminInitialValues?.practiceAreaRate[0]
  );
  const practiceAreaNameToCode = useSelector(state => state?.matter?.practiceAreaNameToCode);
  const [initialValues, setInitialValues] = useState({});

  // Helper to get the current role from roleCodes
  const getRequestedRoleVal = () => {
    return (roleCodes?.length > 0 && roleCodes[0]) ? roleCodes[0] : ''
  }
  const currentRole = getRequestedRoleVal();

  // Page title based on role
  const [pageTitle, setPageTitle] = useState(renderTernary((isTimeKeeperRoleEnabled || currentRole !== OC_ADMIN), EDIT_TIMEKEEPER_TITLE , EDIT_ADMIN_TITLE));

  // Fetch timekeeper data on mount and reset on unmount
  useEffect(() => {
    setLoading(true);
    getTimekeeperData();
    return(()=>{
      dispatch(resetTimeKeeperAdminValue())
    })
  }, []);

  /**
   * Handles API errors by showing a snackbar and stopping loading
   */
  const handleError = (error) => {
    setLoading(false);
    addSnack({
      message: getErrorMessage(error),
    });
  }

  /**
   * Maps backend role codes and flags to display role labels
   */
  const getActualRole = (payload) => {
    if (payload?.isTimeKeeperRoleEnabled === true && payload?.roleCodes[0] === "OC_ADMIN") {
      return ADMIN_TIMEKEEPER_LABEL
    } else if (payload?.isTimeKeeperRoleEnabled === true && payload?.roleCodes[0] === "OC_TIMEKEEPER") {
      return TIMEKEEPER_LABEL
    } else {
      return ADMIN_LABEL
    }
  }

  /**
   * Fetches the timekeeper's data from the API and sets initial state
   */
  const getTimekeeperData = () => {
    getService( USER_REQUEST_SERVICE, `/people/v1/${peopleId}`)
      .then((res) => {
        let payload = res?.data?.result?.people;
        const actualRole = getActualRole(payload);
        payload = {...payload, "requestedRole": actualRole}
        dispatch(setTimekeeperDetail(payload));
        setInitialValues(payload);
        setLoading(false);
      })
      .catch((error) => {
        handleError(error)
      });
  }

  /**
   * Handles changes in input fields and updates both Redux and local state
   */
  const onInputChange = (name, value) => {
    // Special handling for practice area when toggling timekeeper role
    if(name === IS_TIMEKEEPER_ROLE_ENABLED && value === true && practiceArea === undefined || practiceArea?.length === 0 && currentRole === OC_ADMIN){
      dispatch(setInputValue('practiceAreaRate', [practiceAreaInititalValues]));
      setEditValues({...editValues,['practiceAreaRate']:[practiceAreaInititalValues]})
    }else if(name === IS_TIMEKEEPER_ROLE_ENABLED && value === false && practiceArea === undefined || practiceArea?.length === 0 && currentRole === OC_ADMIN){
      dispatch(setInputValue('practiceAreaRate', []));
      setEditValues({...editValues,['practiceAreaRate']:[]})
    }
    dispatch(setInputValue(name, value));
    setEditValues({...editValues,[name]:value})
  };

  /**
   * Handles multi-select for subject matter expertise
   */
  const multiSelectHandler = (e, value) => {
    dispatch(setInputValue('subjectMatterExpertise', value?.toString()));
    setEditValues({...editValues,'subjectMatterExpertise':value?.toString()})
  }

  // Props for LoadField utility
  const loadFieldProps = {
    loader: loading,
    skeletonHeight: '56px',
    skeletonVariant: 'rectangle',
    skeletonLines: 1,
    node: <></>
  };

  /**
   * Handles the update (patch) API call for the profile
   */
  const handleUpdate = () => {
    const roleChangingToTK = initailTkRole !== isTimeKeeperRoleEnabled && isTimeKeeperRoleEnabled === true;
    tabIndex < 2 && (roleChangingToTK) && setTabIndex(tabIndex + 1);
    const practiceAreaData = (roleChangingToTK) && practiceArea?.map((row)=>{
      return(
        {
          "internalUserId"                          : "",
          "userId"                                  : editValues?.emailId,
          "firstName"                               : editValues?.firstName,
          "lastName"                                : editValues?.lastName,
          "emailId"                                 : editValues?.emailId,
          "contactNumber"                           : editValues?.phoneNumber ? phoneNumberForBackend(editValues?.phoneNumber) : null,
          "startDate"                               : convertToUTCDateTime({date:row?.rateStartDate, time: DATE_START_TIME}),
          "endDate"                                 : row?.endDate ? convertToUTCDateTime({date:row?.rateEndDate, time: DATE_END_TIME}) : null,
          "proposedWalmartRate"                     : row?.proposedWalmartRate,
          "currentWalmartRate"                      : row?.currentStandardRate,
          "currentStandardRate"                     : row?.currentStandardRate,
          "outsideOrgJustification"                 : row?.justificationForRate,
          "walmartApprovingAttorneyUserId"          : row?.walmartApprovingAttorneyUserId,
          "walmartApprovingAttorneyFirstName"       : row?.walmartApprovingAttorneyFirstName,
          "walmartApprovingAttorneyLastName"        : row?.walmartApprovingAttorneyLastName,
          "walmartApprovingAttorneyEmailId"         : row?.walmartApprovingAttorneyEmailId,
          "walmartApprovingAttorneyFullName"        : row?.walmartApprovingAttorneyFullName,
          "practiceAreaCode"                        : convertPANameToCode(row?.practiceArea, practiceAreaNameToCode)
        }
      )
    })   
    if (tabIndex === 2 || !isTimeKeeperRoleEnabled || (initailTkRole === isTimeKeeperRoleEnabled)){
    setLoading(true);
    const body = {
      firstName:editValues?.firstName,
      lastName:editValues?.lastName,
      emailId:editValues?.emailId,
      primaryOfficeLocation:editValues?.primaryOfficeLocation,
      stateBarLicence:editValues?.stateBarLicence,
      subjectMatterExpertise:editValues?.subjectMatterExpertise,
      justificationForRole:editValues?.justificationForRole,
      tkId:editValues?.tkId,
      classification:editValues?.classification,
      billingContact:editValues?.billingContact,
      organizationName:editValues?.organizationName,
      phoneNumber: phoneNumberForBackend(editValues?.phoneNumber),
      role:editValues?.role,
      jdYear:editValues?.jdYear,
      endDate:(editValues?.endDate && editValues?.endDate !== "Invalid date") ? convertToUTCDateTime({date:editValues?.endDate, time: DATE_END_TIME}): null,
      walmartApprovingAttorneyEmailId:editValues?.walmartApprovingAttorneyEmailId,
      walmartApprovingAttorneyFirstName:editValues?.walmartApprovingAttorneyFirstName,
      walmartApprovingAttorneyFullName:editValues?.walmartApprovingAttorneyFullName,
      walmartApprovingAttorneyLastName:editValues?.walmartApprovingAttorneyLastName,
      walmartApprovingAttorneyUserId:editValues?.walmartApprovingAttorneyUserId,
      addressType: editValues?.addressType,
      addressLine1: editValues?.addressLine1,
      addressLine2: editValues?.addressLine2,
      city: editValues?.city,
      state: editValues?.state,
      country: editValues?.country,
      isTimeKeeperRoleEnabled: initailTkRole === isTimeKeeperRoleEnabled ? null : isTimeKeeperRoleEnabled,
      roleCodes: roleCodes
    }

    if (isTimeKeeperRoleEnabled) {
        body["stateBarLicence"] = editValues?.stateBarLicence;
        body["tkId"] = editValues?.tkId;
        body["subjectMatterExpertise"] = editValues?.subjectMatterExpertise;
        body["classification"] = editValues?.classification;
        if (editValues?.jdYear) {
          body["jdYear"] = Number(editValues?.jdYear);
        }
        if (roleChangingToTK) {
          body["practiceAreaSpecificRates"] = practiceAreaData;
        }
    }
    const filteredBody=filterPayload(body)
    if(editValues?.endDate === null || editValues?.endDate == "Invalid date" || editValues?.endDate == "") {
      filteredBody.endDate = null
    }  
    patchService(USER_REQUEST_SERVICE, `/people/v1/${peopleId}`, filteredBody)
      .then((res) => {
        saveUserRequestData(filteredBody);
        addSnack({
          message: USER_DETAILS_UPDATE_MSG,
        });
        history.push(`/people/${peopleId}/view`)
      })
      .catch((error) => {
        handleError(error)
        setEditValues({})
        setLoading(false)
      });
    }
  }

  /**
   * Gets called when clicked on cancel button.
   */
  const handleGoBack = () => {
    tabIndex > 0 && setTabIndex(tabIndex - 1);
  };

  const handleCancel = () => {
      history.push(`/people/${peopleId}/view`)
  };

  /** Function will use for handle walmart attorney dropdown */
  const handleWalmartAttorney = (value) =>{
    setWalmartTimekeeperAttorney(value);
  }

  // Syncs Walmart attorney fields to Redux and local state when changed
  useEffect(()=>{
    dispatch(setInputValue('walmartApprovingAttorneyEmailId', (walmartTimekeeperAttorney?.email ? walmartTimekeeperAttorney?.email : '')));
    dispatch(setInputValue('walmartApprovingAttorneyFirstName',walmartTimekeeperAttorney?.firstName));
    dispatch(setInputValue('walmartApprovingAttorneyFullName',`${walmartTimekeeperAttorney?.firstName} ${walmartTimekeeperAttorney?.lastName}`));
    dispatch(setInputValue('walmartApprovingAttorneyLastName',walmartTimekeeperAttorney?.lastName));
    dispatch(setInputValue('walmartApprovingAttorneyUserId',walmartTimekeeperAttorney?.userId));
    if(walmartTimekeeperAttorney?.firstName !== walmartApprovingAttorneyFirstName)//update editValues only when there is a change
    {  setEditValues({...editValues,['walmartApprovingAttorneyEmailId']:walmartTimekeeperAttorney?.email,
      ['walmartApprovingAttorneyFirstName']:walmartTimekeeperAttorney?.firstName,
      ['walmartApprovingAttorneyFullName']:walmartTimekeeperAttorney?.firstName ? `${walmartTimekeeperAttorney?.firstName} ${walmartTimekeeperAttorney?.lastName}`: null,
      ['walmartApprovingAttorneyLastName']:walmartTimekeeperAttorney?.lastName,
      ['walmartApprovingAttorneyUserId']:walmartTimekeeperAttorney?.userId,})
    }
  },[walmartTimekeeperAttorney])

  // Syncs Walmart attorney state when first name changes
  useEffect(()=>{
    { setWalmartTimekeeperAttorney(walmartApprovingAttorneyFirstName ? {
      email: walmartApprovingAttorneyEmailId,
      firstName: walmartApprovingAttorneyFirstName,
      lastName: walmartApprovingAttorneyLastName,
      userId: walmartApprovingAttorneyUserId,
    }:'')}
  },[walmartApprovingAttorneyFirstName])

  // Validates end date is not before start date
  useEffect(() => {
    if (endDate && (new Date(endDate) < new Date(startDate))) {
      setError('endDate', { type: 'custom', message: START_END_DATE_VALIDATION_MESSAGE });
    }
    else {
      clearErrors('endDate')
    }
  }, [endDate])

  // Validates subject matter expertise is not empty
  useEffect(() => {
    if (subjectMatterExpertise?.length === 0) {
      setError('subjectMatterExpertise', { type: 'custom', message: SUBJECT_MATTER_EXPERTISE_MSG });
    }
    else {
      clearErrors('subjectMatterExpertise')
    }
  }, [subjectMatterExpertise])

  /**
   * Saves user request data to the backend
   */
  const saveUserRequestData = (body) => {
    body['roleCodes'] = roleCodes;
    patchService(USER_REQUEST_SERVICE, `/user-requests/v1/${userRequestId}/update`, body)
      .then(() => {
        setLoading(false)
        setEditValues({})
      })
      .catch((error) => {
        setLoading(false);
        addSnack({
          message: getErrorMessage(error)
        });
        setEditValues({})
      });
  }

  /**
   * Handles role change in the role dropdown, updates related fields
   */
  const handleRoleChange = (e,name) => {
    onInputChange(name, e.target.value)
    if (e.target.value === ADMIN_TIMEKEEPER_LABEL) {
      onInputChange("roleCodes", [OC_ADMIN])
      onInputChange(IS_TIMEKEEPER_ROLE_ENABLED, true);
    } else if (e.target.value === TIMEKEEPER_LABEL) {
      onInputChange("roleCodes", [OC_TIMEKEEPER])
      onInputChange(IS_TIMEKEEPER_ROLE_ENABLED, true);
    } else {
      onInputChange("roleCodes", [OC_ADMIN])
      onInputChange(IS_TIMEKEEPER_ROLE_ENABLED, false);
    }
  }

  // Tracks if the form is dirty (has unsaved changes)
  let isDirty = false;
  isDirty = isTimeKeeperRoleEnabled !== initialValues?.isTimeKeeperRoleEnabled || firstName !== initialValues?.firstName || lastName !== initialValues?.lastName || emailId !== initialValues?.emailId
  || cleanValueString(primaryOfficeLocation) !== cleanValueString(initialValues?.primaryOfficeLocation)
  || cleanValueString(stateBarLicence) !== cleanValueString(initialValues?.stateBarLicence) || subjectMatterExpertise
   !== initialValues?.subjectMatterExpertise || cleanValueString(justificationForRole)
    !== cleanValueString(initialValues?.justificationForRole)
   || tkId !== initialValues?.tkId || classification !== initialValues?.classification
   || cleanValueString(organizationName) !== cleanValueString(initialValues?.organizationName)
    || cleanValueString(phoneNumber) !== cleanValueString(initialValues?.phoneNumber)
   || cleanValueString(jdYear) !== cleanValueString(initialValues?.jdYear) || moment(endDate).format(DATE_YYYY_MM_DD)
     !== moment(initialValues?.endDate).format(DATE_YYYY_MM_DD) || moment(endDate).format(DATE_YYYY_MM_DD) === "Invalid Date" || moment(startDate).format(DATE_YYYY_MM_DD)
     !== moment(initialValues?.startDate).format(DATE_YYYY_MM_DD) ||
    cleanValueString(walmartApprovingAttorneyUserId) !==
    cleanValueString(initialValues?.walmartApprovingAttorneyUserId) ||
    requestedRole !== initialValues?.requestedRole

    if(tabIndex ===1){
      isDirty = practiceArea?.filter((row)=> isValueValidList([row?.practiceArea, row?.rateStartDate, row?.walmartApprovingAttorneyFirstName, row?.proposedWalmartRate, row?.currentStandardRate])).length === practiceArea?.length
    }
    

  const TimeKeeperForm = <>
    <GridColumn sm={12}>
      <div className={classes.divider2}>
        <Divider />
      </div>
    </GridColumn>
    <GridColumn sm={9}>
      <div className={classes.leftContent}>
        <div className={classes.contentSpacing16}>
          <h2>{APPROVAL_DATA}</h2>
        </div>
        <div className={classes.contentSpacing16}>
          {LoadField({
            ...loadFieldProps, node: <React.Fragment>
              <Label text={STATE_BAR_LICENCE} />
              <MasterDataAutocomplete
              value={stateBarLicence}
              setValue={(value)=>{onInputChange("stateBarLicence", value?.value)}}
              dataType={"stateBarLicense"}
              testid="edittimekeeperprofile-starBarLicense"
              id="edittimekeeperprofile-starBarLicense"
              required = {true}
              register={register}
              errors={errors}
              name={"stateBarLicence"}
              validationRules = {timekeeperValidationRules}
              placeholderValue={SELECT_STATE_BAR_LICENSE}
              />
            </React.Fragment>
          })}
        </div>
        <div className={classes.contentSpacing16}>
          {LoadField({
            ...loadFieldProps, node: <React.Fragment>
              <div className={classes.labelStyle}><Label text={SUBJECT_MATTER_EXPERTISE} mandatoryField={true}/></div>
              <MasterDataMultiAutocomplete
                dataType={"subjectMatterExpertise"}
                value={subjectMatterExpertise?.length > 0 ? subjectMatterExpertise?.split(','): []}
                placeholderValue={SELECT_SUBJECT_MATTER_EXPERTISE}
                setValue={multiSelectHandler}
                testid="create-timekeeper-subject-matter-expertise"
                id="create-timekeeper-subject-matter-expertise"
              />
              <div className={classes.errorMsg}>{errors?.subjectMatterExpertise && <MuiValidationMessage message={errors?.subjectMatterExpertise.message} />}</div>
            </React.Fragment>
          })}
        </div>
        <div className={classes.contentSpacing16}>
          {LoadField({
            ...loadFieldProps, node: <React.Fragment>
              <Label text={JUSTIFICATION_FOR_TIMEKEEPER} />
              <TextArea
                error={errors?.justificationForRole && <MuiValidationMessage message={errors?.justificationForRole?.message} mode="LD" />}
                value={justificationForRole}
                maxLength={CHARACTER_LIMIT}
                textAreaProps={{
                  name: "justificationForRole",
                }}
                data-testid="edittimekeeperprofile-justificationfortimekeeper"
                {...register(
                  'justificationForRole',
                  { ...timekeeperValidationRules?.justificationForTimeKeeper, onChange: (e) => onInputChange(e.target.name, e.target.value) }
                )}
              />
            </React.Fragment>
          })}
        </div>
      </div>
    </GridColumn>
    <GridColumn sm={3} className={classes.gridColumn}>
      <div className={classes.approvalDataRightSection}>
        {LoadField({
          ...loadFieldProps, node: <React.Fragment>
            <Label text={JD_YEAR} />
            <TextField
              onChange={(e) => onInputChange(e.target.name, e.target.value)}
              value={jdYear}
              name= "jdYear"
              type="text"
              data-testid="edittimekeeperprofile-jdyear"
              fullWidth={true}
            />
          </React.Fragment>
        })}
      </div>
      <div className={classes.contentSpacing16}>
        {LoadField({
          ...loadFieldProps, node: <React.Fragment>
            <Label text={WALMART_APPOVING_ATTORNEY} />
            <PeopleAutocompleteWithOptions
              value={walmartTimekeeperAttorney}
              required={true}
              setValue={(value) => {
                handleWalmartAttorney(value);
              }}
              placeholderValue={'Select Walmart Approving Attorney'}
              filterCheck={false}
              testid="edittimekeeperprofile-walmart-approving-attroney"
              id="edittimekeeperprofile-walmart-approving-attroney"
              register={register}
              errors={errors}
              name={"walmartTimekeeperAttorney"}
              validationRules={timekeeperValidationRules}
              additionalQuery={CS_IS_OC_INTERNAL_FILTER}
            />
          </React.Fragment>
        })}
      </div>
      <div className={classes.contentSpacing24}><Label text={REQUESTER_EMAIL}/></div>
      <div className={classes.contentSpacing16}>
        {requesterEmailId}
      </div>
    </GridColumn>
    <GridColumn sm={12}>
      <div className={classes.divider2}>
        <Divider />
      </div>
    </GridColumn>
    <GridColumn sm={9}>
      <div className={classes.leftContent}>
        <div className={classes.contentSpacing16}>
          <h2>{DETAILS}</h2>
        </div>
        {LoadField({
          ...loadFieldProps, node: <React.Fragment>
            <Label text={TKID} />
            <TextField
              error={errors?.tkId}
              helperText={errors?.tkId && <MuiValidationMessage message={errors?.tkId?.message}/>}
              value={tkId}
              name= "tkId"
              type="text"
              data-testid="edittimekeeperprofile-tkid"
              {...register(
                'tkId',
                { ...timekeeperValidationRules?.tkId, onChange: (e) => onInputChange(e.target.name, e.target.value) }
              )}
              fullWidth={true}
            />
          </React.Fragment>
        })}
        <div className={classes.contentSpacing16}>
          {LoadField({
            ...loadFieldProps, node: <React.Fragment>
              <Label text={CLASSIFICATION} />
              <MasterDataAutocomplete
              value={classification}
              setValue={(value)=>{onInputChange("classification", value?.value)}}
              dataType={"classification"}
              testid="edittimekeeperprofile-classification"
              placeholderValue={SELECT_CLASSIFICATION}
              required={true}
              register={register}
              errors={errors}
              validationRules = {timekeeperValidationRules}
              name={"classification"}
              />
            </React.Fragment>
          })}
        </div>
        <div className={classes.contentSpacing16}>
          <Switch
            isOn={billingContact}
            label={<span>{BILLING_CONTACT}</span>}
            onClick={() => {
              onInputChange("billingContact", !billingContact);
            }}
            data-testid="edittimekeeperprofile-billingContact"
            name="billingContact"
          />
        </div>
      </div>
    </GridColumn>
    <GridColumn sm={3} className={classes.gridColumn}>
      <div className={classes.createdDate}>
        <Label text={CREATED_DATE} />
      </div>
      <div className={classes.contentSpacing16}>{moment(Date.now()).format(MOMENT_DATE_FORMAT)}</div>
      <div className={classes.contentSpacing42}>
        {LoadField({
          ...loadFieldProps, node: <React.Fragment>
            <Label text={START_DATE} />
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                sx={{width:"100%"}}
                value={renderTernary(startDate, moment.utc(startDate).local(), null)}
                minDate={moment().subtract(2, 'years')}
                onChange={(e) => {
                  onInputChange(
                    'startDate',
                    e ? moment(e).format(BACKEND_DATE_FORMAT) : null
                  );
                }}
                slotProps={{
                  inputAdornment: { position: "end" },
                  textField: {
                    InputProps: { style: { color: '#2E2F32' } },
                    name: "startDate",
                    "data-testid": "edittimekeeperprofile-startDate"
                  }
                }}
              />
            </LocalizationProvider>
          </React.Fragment>
        })}
      </div>
      <div className={classes.contentSpacing24}>
        {LoadField({
          ...loadFieldProps, node: <React.Fragment>
            <Label text={END_DATE} />
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                sx={{width:"100%"}}
                value={renderTernary(endDate, moment.utc(endDate).local(), null)}
                onChange={(e) => {
                  onInputChange(
                    'endDate',
                    e ? moment(e).format(BACKEND_DATE_FORMAT) : null
                  );
                }}
                slotProps={{inputAdornment:{position:"end"},textField:{InputProps:{style: { color: '#2E2F32' }},name:"endDate","data-testid" : "edittimekeeperprofile-enddate"}}}
              />
            </LocalizationProvider>
            <div className={classes.errorMsg}>{errors?.endDate && <MuiValidationMessage message={errors?.endDate.message} />}</div>
          </React.Fragment>
        })}
      </div>
    </GridColumn>
  </>;

  const AdminForm = <>
    <GridColumn sm={12}>
      <div className={classes.divider2}>
        <Divider />
      </div>
    </GridColumn>
    <GridColumn sm={9}>
      <div className={classes.leftContent}>
        <div className={classes.contentSpacing16}>
          <h2>{APPROVAL_DATA}</h2>
        </div>
        <div className={classes.contentSpacing16}>
          {LoadField({
            ...loadFieldProps, node: <React.Fragment>
              <Label text={JUSTIFICATION_FOR_TIMEKEEPER} />
              <TextArea
                error={errors?.justificationForRole && <MuiValidationMessage message={errors?.justificationForRole?.message} mode="LD" />}
                value={justificationForRole}
                maxLength={CHARACTER_LIMIT}
                textAreaProps={{
                  name: "justificationForRole",
                }}
                data-testid="edittimekeeperprofile-justificationfortimekeeper"
                {...register(
                  'justificationForRole',
                  { ...timekeeperValidationRules?.justificationForTimeKeeper, onChange: (e) => onInputChange(e.target.name, e.target.value) }
                )}
              />
            </React.Fragment>
          })}
        </div>
      </div>
    </GridColumn>
    <GridColumn sm={3} className={classes.gridColumn}>
      <div className={classes.contentSpacing16}>
        {LoadField({
          ...loadFieldProps, node: <React.Fragment>
            <Label text={WALMART_APPOVING_ATTORNEY} />
            <PeopleAutocompleteWithOptions
              value={walmartTimekeeperAttorney}
              required={true}
              setValue={(value) => {
                handleWalmartAttorney(value);
              }}
              placeholderValue={'Select Walmart Approving Attorney'}
              filterCheck={false}
              testid="edittimekeeperprofile-walmart-approving-attroney"
              id="edittimekeeperprofile-walmart-approving-attroney"
              register={register}
              errors={errors}
              name={"walmartTimekeeperAttorney"}
              validationRules={timekeeperValidationRules}
              additionalQuery={CS_IS_OC_INTERNAL_FILTER}
            />
          </React.Fragment>
        })}
      </div>
      <div className={classes.contentSpacing24}><Label text={REQUESTER_EMAIL}/></div>
      <div className={classes.contentSpacing16}>
        {requesterEmailId}
      </div>
    </GridColumn>
    <GridColumn sm={12}>
      <div className={classes.divider2}>
        <Divider />
      </div>
    </GridColumn>
    <GridColumn sm={9}>
      <div className={classes.leftContent}>
        <div className={classes.contentSpacing16}>
          <h2>{DETAILS}</h2>
        </div>
        <div className={classes.contentSpacing16}>
          <Switch
            isOn={billingContact}
            label={<span>{BILLING_CONTACT}</span>}
            onClick={() => {
              onInputChange("billingContact", !billingContact);
            }}
            data-testid="edittimekeeperprofile-billingContact"
            name="billingContact"
          />
        </div>
        <div className={classes.createdDate}>
          <Label text={CREATED_DATE} />
        </div>
        <div className={classes.contentSpacing16}>{moment(Date.now()).format(MOMENT_DATE_FORMAT)}</div>
      </div>
    </GridColumn>
    <GridColumn sm={3} className={classes.gridColumn}>
      <div className={classes.contentSpacing42}>
        {LoadField({
          ...loadFieldProps, node: <React.Fragment>
            <Label text={START_DATE} />
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                sx={{width:"100%"}}
                minDate={moment().subtract(2, 'years')}
                value={renderTernary(startDate, moment.utc(startDate).local(), null)}
                onChange={(e) => {
                  onInputChange(
                    'startDate',
                    e ? moment(e).format(BACKEND_DATE_FORMAT) : null
                  );
                }}
                slotProps={{inputAdornment:{position:"end"},textField:{InputProps:{style: { color: '#2E2F32' }},name:"startDate","data-testid":"edittimekeeperprofile-startDate"}}}
              />
            </LocalizationProvider>
          </React.Fragment>
        })}
      </div>
      <div className={classes.contentSpacing24}>
        {LoadField({
          ...loadFieldProps, node: <React.Fragment>
            <Label text={END_DATE} />
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DatePicker
                sx={{width:"100%"}}
                value={renderTernary(endDate, moment.utc(endDate).local(), null)}
                onChange={(e) => {
                  onInputChange(
                    'endDate',
                    e ? moment(e).format(BACKEND_DATE_FORMAT) : null
                  );
                }}
                slotProps={{inputAdornment:{position:"end"},textField:{InputProps:{style: { color: '#2E2F32' }},name:"endDate","data-testid" : "edittimekeeperprofile-enddate"}}}
              />
            </LocalizationProvider>
            <div className={classes.errorMsg}>{errors?.endDate && <MuiValidationMessage message={errors?.endDate.message} />}</div>
          </React.Fragment>
        })}
      </div>
    </GridColumn>
  </>
  
  let isTimeKeeperForm;
  if (!loading) {
    if (isTimeKeeperRoleEnabled || currentRole !== OC_ADMIN) {
      isTimeKeeperForm = TimeKeeperForm
    } else {
      isTimeKeeperForm = AdminForm
    }
  }

  /**
 * Gets called when clicked on Add Another Rate button.
 */
  const handleSetPracticeArea = () => {
    const newPracticeAreaFields = {
      ...practiceAreaInititalValues,
      id: practiceArea?.length + 1,
    };
    dispatch(setPracticeAreaNew(newPracticeAreaFields));
  };

  const createTimekeeper =    
      <Grid>
        <GridColumn sm={9}>
          <div className={classes.leftContent}>
            <h2>{CONTACT_INFO}</h2>
            <Grid className={classes.grid}>
              <GridColumn lg={6}>
                {LoadField({
                  ...loadFieldProps, node: <React.Fragment>
                    <Label text={FIRST_NAME} mandatoryField={true} />
                    <TextField
                      error={errors?.firstName}
                      helperText={errors?.firstName && <MuiValidationMessage message={errors?.firstName?.message}/>}
                      value={firstName}
                      name= "firstName"
                      type="text"
                      data-testid="edittimekeeperprofile-firstname"
                      id="edittimekeeperprofile-firstname"
                      {...register(
												'firstName',
												{ ...timekeeperValidationRules?.firstName, onChange: (e) => onInputChange(e.target.name, e.target.value) }
											)}
                      fullWidth={true}
                    />
                  </React.Fragment>
                })}
              </GridColumn>
              <GridColumn lg={5}>
                {LoadField({
                  ...loadFieldProps, node: <React.Fragment>
                    <Label text={LAST_NAME} mandatoryField={true} />
                    <TextField
                      error={errors?.lastName}
                      helperText={errors?.lastName && <MuiValidationMessage message={errors?.lastName?.message}/>}
                      value={lastName}
                      name= "lastName"
                      type="text"
                      data-testid="edittimekeeperprofile-lastname"
                      id="edittimekeeperprofile-lastname"
                      {...register(
												'lastName',
												{ ...timekeeperValidationRules?.lastName, onChange: (e) => onInputChange(e.target.name, e.target.value) }
											)}
                      fullWidth={true}
                    />
                  </React.Fragment>
                })}
              </GridColumn>
            </Grid>
            <div className={classes.contentSpacing16}>
              {LoadField({
                ...loadFieldProps, node: <React.Fragment>
                  <Label text={EMAIL} mandatoryField={true} />
                  <TextField
                    error={errors?.email}
                    helperText={errors?.email && <MuiValidationMessage message={errors?.email?.message}/>}
                    value={emailId}
                    name= "emailId"
                    id= "emailId"
                    type="text"
                    disabled={true}
                    data-testid="edittimekeeperprofile-email"
                    {...register(
                      'emailId',
                      { ...timekeeperValidationRules?.email, onChange: (e) => onInputChange(e.target.name, e.target.value) }
                    )}
                    fullWidth={true}
                  />
                </React.Fragment>
              })}
            </div>
            <div className={classes.contentSpacing16}>
              {LoadField({
                ...loadFieldProps, node: 
                <Grid className={classes.grid}>
                <GridColumn sm={6}>
                  <Label text={ROLE} mandatoryField={true}/>
                  <Select
                  onChange={(e)=>handleRoleChange(e,"requestedRole")}
                  value={requestedRole}
                  selectProps={{
                    name: "requestedRole",
                  }}
                  data-testid="edittimekeeperprofile-role"
                  fullWidth={true}
                >
                  <MenuItem value="">{"Select Role"}</MenuItem>
                  {[ADMIN_LABEL, TIMEKEEPER_LABEL, ADMIN_TIMEKEEPER_LABEL]?.map((value, index) => {
                    return (
                      <MenuItem
                        value={value}
                        key={`${value}`}
                        data-testid="edit-timekeeper-role-option"
                      >
                        {value}
                      </MenuItem>
                    );
                  })}
                </Select>
                </GridColumn>
                <GridColumn sm={5}>
                  <Label text={ORGANIZATION} mandatoryField={true}/>
                  <text className={classes.companyNameStyle}>{organizationName}</text>
                </GridColumn>
                </Grid>
              })}
            </div>
            <div className={classes.contentSpacing16}>
            {LoadField({
                ...loadFieldProps, node: <React.Fragment>
                <Label text={PHONE_NUMBER} />
                <TextField
                  error={errors?.phoneNo}
                  helperText={errors?.phoneNo && <MuiValidationMessage message={errors?.phoneNo?.message}/>}
                  value={formatPhoneNumber(phoneNumber)}
                  name= "phoneNumber"
                  id= "phoneNumber"
                  type="tel"
                  data-testid="edittimekeeperprofile-phoneno"
                  {...register(
                    'phoneNumber',
                    { ...timekeeperValidationRules?.phoneNo, onChange: (e) => onInputChange(e.target.name, formatPhoneNumber(e.target.value)) }
                  )}
                  fullWidth={true}
                />
              </React.Fragment>
            })}
          </div>
          </div>
        </GridColumn>
        <GridColumn sm={3} className={classes.gridColumn}>
          {LoadField({
            ...loadFieldProps, node: <React.Fragment>
              <Label text={ADDRESS_TYPE} mandatoryField={true} />
              <Select
                error={errors?.addressType}
                value={addressType}
                name= "addressType"
                data-testid="edit-timekeeper-addressType"
                id="edit-timekeeper-addressType"
                {...register(
                  'addressType',
                  { ...timekeeperValidationRules?.addressType, onChange: (e) => onInputChange(e.target.name, e.target.value) }
                )}
                fullWidth={true}
              >
                <MenuItem value="">{SELECT_TYPE}</MenuItem>
                {AddressTypes?.map((value, index) => {
                  return (
                    <MenuItem
                      value={value}
                      key={`${value}`}
                      id={`create-timekeeper-addressType-option-${index}`}
                    >
                      {value}
                    </MenuItem>
                  );
                })}
              </Select>
              <div className={classes.errorMsg}>{errors?.addressType && <MuiValidationMessage message={errors?.addressType?.message} />}</div>
            </React.Fragment>
          })}
          <div className={classes.contentSpacing16}>
            {LoadField({
              ...loadFieldProps, node: <React.Fragment>
                <Label text={ADDRESS_LINE_1} mandatoryField={true} />
                <TextField
                error={errors?.addressLine1}
                helperText={errors?.addressLine1 && <MuiValidationMessage message={errors?.addressLine1?.message}/>}
                value={addressLine1}
                name= "addressLine1"
                type="text"
                data-testid="edit-timekeeper-addressLine1"
                {...register(
                  'addressLine1',
                  { ...timekeeperValidationRules?.addressLine1, onChange: (e) => onInputChange(e.target.name, e.target.value) }
                )}
                fullWidth={true}
              />
              </React.Fragment>
            })}
          </div>
          <div className={classes.contentSpacing16}>
            {LoadField({
              ...loadFieldProps, node: <React.Fragment>
                <Label text={ADDRESS_LINE_2} />
                <TextField
                  onChange={(e) => {
                    onInputChange(e.target.name, e.target.value);
                  }}
                  value={addressLine2}
                  name= "addressLine2"
                  id= "addressLine2"
                  type="text"
                  data-testid="edit-timekeeper-addressLine2"
                  fullWidth={true}
              />
              </React.Fragment>
            })}
          </div>
          <div className={classes.contentSpacing16}>
            {LoadField({
              ...loadFieldProps, node: <Grid className={classes.grid}>
              <GridColumn sm={6}>
                <Label text={CITY} />
                <TextField
                  onChange={(e) => {
                    onInputChange(e.target.name, e.target.value);
                  }}
                  value={city}
                  name= "city"
                  type="text"
                  data-testid="edit-timekeeper-city"
                  fullWidth={true}
              />
              </GridColumn>
              <GridColumn sm={5}>
                <Label text={STATE} />
                <MasterDataAutocomplete
                  value={state}
                  setValue={(value)=>{onInputChange("state", value?.value)}}
                  dataType={"state"}
                  name={"state"}
                  testid="edit-timekeeper-state"
                  placeholderValue={SELECT_STATE}
                  />
                </GridColumn>
              </Grid>
            })}
          </div>
          <div className={classes.contentSpacing16}>
            {LoadField({
              ...loadFieldProps, node: <React.Fragment>
                <Label text={COUNTRY} />
                <MasterDataAutocomplete
                  value={country}
                  setValue={(value)=>{onInputChange("country", value?.value)}}
                  dataType={"country"}
                  name={"country"}
                  testid="edit-timekeeper-country"
                  placeholderValue={SELECT_COUNTRY}
                  />
              </React.Fragment>
            })}
          </div>
        </GridColumn>
        {isTimeKeeperForm}
      </Grid>

  const LoadTabContent = (register, errors, practiceArea, handleSetPracticeArea, tabIndex, setError, clearErrors) => {
    switch (tabIndex) {
      case 0: return createTimekeeper;
      case 1: return (
        <>
          {practiceArea?.map((row, idx) => (
            <TimeKeeperAdminCreatePracticeArea
              order={idx}
              selectedRow={idx}
              key={row?.internalUserId}
              register={register} errors={errors}
              setError={setError} clearErrors={clearErrors}
            />
          ))}
          <div className={classes.addPracticeAreaButton}>
            <Button
              variant="tertiary"
              onClick={handleSetPracticeArea}
              data-testid={`practice-area-add-btn`}
              leading={<Plus size="small" />}
            >
              {ADD_ANOTHER_RATE}
            </Button>
          </div>
        </>
      );
      default: return <TimeKeeperAdminSummary mode={EDIT} />;
    }
  }

  return (
    <div className={classes.wrapper}>
      {isTimeKeeperRoleEnabled?
      <ProgressTracker
        activeIndex={tabIndex}
        variant="info"
        className={classes.progressTracker}
      >
        <ProgressTrackerItem>{PROFILE_INFO}</ProgressTrackerItem>
        <ProgressTrackerItem>{RATE}</ProgressTrackerItem>
        <ProgressTrackerItem>{SUMMARY}</ProgressTrackerItem>
      </ProgressTracker>:
      <></>}
    <Detail
      mode={modes.EDIT}
      setMode={() => { }}
      breadcrumbValues={[]}
      onUpdate={handleUpdate}
      onCancel={handleGoBack}
      editBtnTxt={renderTernary((tabIndex === 2 || (!isTimeKeeperRoleEnabled) || (initailTkRole === isTimeKeeperRoleEnabled)), UPDATE , NEXT)}
      loading={loading}
      isDirty={isDirty}
      isValid={true}
      hideDeleteBtn
      cancelText={GO_BACK}
      disableCancel={tabIndex === 0}
      footerActions={
        <Button
          variant="tertiary"
          onClick={handleCancel}
          data-testid={`footer-cancel-button`}
        >
          {CANCEL}
        </Button>
      }
    >
      <div className={classes.leftContent}>
        <Heading as="h1" size="large">
          {pageTitle}
        </Heading>
      </div>
        {LoadTabContent(register, errors,practiceArea,handleSetPracticeArea,tabIndex,setError, clearErrors)}      
    </Detail>
    </div>
  );
};

export default EditTimeKeeperProfile;
